var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkerEmployee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12459",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16617",
    transform: "translate(0 -1.526)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12463",
    d: "M18.091 8.901l2.2-3.353a1 1 0 00-.871-1.496h-3.411a1 1 0 00-.868.5l-3 4.345",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12464",
    d: "M5.7 8.762l-1.988-3.21a1 1 0 01.868-1.5h3.411a1 1 0 01.868.5l2.768 4.21",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16613"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12467",
    d: "M19 23H5a3 3 0 01-3-3v-8a3 3 0 013-3h14a3 3 0 013 3v8a3 3 0 01-3 3z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12474",
    d: "M18.34 15H12.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12475",
    d: "M16.5 18h-4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 637",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(5 14)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
}
export default SvgWorkerEmployee;


//////////////////
// WEBPACK FOOTER
// ./src/icons/workerEmployee.svg
// module id = 803
// module chunks = 11